import ReactMarkdown from "react-markdown";
import rehypeSanitize from "rehype-sanitize";

/** Sanitized Markdown renderer used for content previews and (later) the employee view. */
export function Markdown({ children }: { children: string }) {
  return (
    <div className="md">
      <ReactMarkdown rehypePlugins={[rehypeSanitize]}>{children || "_Nog geen inhoud._"}</ReactMarkdown>
    </div>
  );
}
